export default "__VITE_ASSET__DlOhAfjP__"